<script>
  const COUNT_DEBOUNCE = 300

  export default {
    beforeDestroy() {
      clearTimeout(this.countTimeout)
    },
    computed: {
      hasTypes() {
        return this.selectedDocuments.length > 0
      },
      overLimit() {
        return !!this.count && this.count[this.scope].over_limit
      },
      selectedCount() {
        return this.checkAll ? this.totalCount : this.selectedTickets.length
      },
      showModal: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    data: () => ({
      count: null,
      countSource: null,
      countTimeout: null,
      exportSource: null,
      folderMode: 'per_ait',
      isExporting: false,
      loadingCount: false,
      notice: null,
      scope: 'latest',
      selectedDocuments: []
    }),
    methods: {
      abortExport() {
        if (this.exportSource)
          this.exportSource.cancel()
      },
      buildQuery() {
        if (!this.checkAll)
          return { id: this.selectedTickets.map(ticket => ticket.id) }

        const query = { ...(this.buildParams().q || {}) }

        if (query.generic)
          query.generic = decodeURIComponent(query.generic)

        return query
      },
      cancel() {
        this.showModal = false
      },
      exportDocuments() {
        if (!this.hasTypes || this.overLimit) return

        this.exportSource = this.axios.CancelToken.source()
        this.isExporting = true

        this.requestExport(this.buildQuery(), this.selectedDocuments, this.exportSource.token)
          .then(response => {
            if (response.data)
              this.$parse.downloadByLink(response.data)

            this.$notify.add(this.noticeOf(response) || 'Documentos exportados com sucesso')
            this.showModal = false
          })
          .catch(e => {
            if (!this.axios.isCancel(e))
              this.$notify.addError(e)
          })
          .finally(() => this.isExporting = false)
      },
      loadCount() {
        if (this.countSource)
          this.countSource.cancel()

        this.countSource = this.axios.CancelToken.source()
        this.loadingCount = true

        this.requestCount(this.buildQuery(), this.selectedDocuments, this.countSource.token)
          .then(response => {
            this.count = response.data
            this.notice = this.noticeOf(response)
            this.loadingCount = false
          })
          .catch(e => {
            if (this.axios.isCancel(e)) return

            this.count = null
            this.loadingCount = false
          })
      },
      noticeOf(response) {
        return response.meta && response.meta.notice
      },
      scheduleCount() {
        clearTimeout(this.countTimeout)

        if (!this.hasTypes) {
          this.count = null
          return
        }

        this.countTimeout = setTimeout(() => this.loadCount(), COUNT_DEBOUNCE)
      }
    },
    name: 'DocumentExporter',
    props: {
      buildParams: {
        type: Function,
        default: null
      },
      checkAll: {
        type: Boolean,
        default: false
      },
      selectedTickets: {
        type: Array,
        required: true
      },
      totalCount: {
        type: Number,
        default: 0
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      selectedDocuments() {
        this.scheduleCount()
      },
      value(newValue) {
        if (newValue) return

        clearTimeout(this.countTimeout)
        this.abortExport()

        this.selectedDocuments = []
        this.scope = 'latest'
        this.folderMode = 'per_ait'
        this.count = null
        this.notice = null
      }
    }
  }
</script>
